// Auth service (Firebase/OAuth) boilerplate

import { auth } from '../firebaseConfig';
import { GoogleAuthProvider, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, signInWithPopup } from 'firebase/auth';

const provider = new GoogleAuthProvider();

export const login = async (email: string, password: string) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const signup = async (email: string, password: string) => {
  return createUserWithEmailAndPassword(auth, email, password);
};

export const logout = async () => {
  return signOut(auth);
};

export const loginWithGoogle = async () => {
  return signInWithPopup(auth, provider);
};

export { auth }; 